import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import i18nBackend, { type ChainedBackendOptions } from 'i18next-chained-backend';
import i18nBackendHttp from 'i18next-http-backend';
import i18nBackendLS from 'i18next-localstorage-backend';

import { getLanguageFromLocation } from '@/helpers/getLanguageFromLocation';
import { isShadowMode, shadowModeParams } from '@/config';
import { languages, shadowRootModePrefix } from '@/config/constants';

const lng = getLanguageFromLocation();

const versions = languages.reduce((acc, lang) => ({ ...acc, [lang]: process.env.I18N }), {});

//additional check if localstorage exists but forbidden due to iframe different domain
const getBackend = () => {
  const backend: ChainedBackendOptions = {
    backendOptions: [
      {
        loadPath: ([lng]: [string]) => {
          let path = `/dist/i18n/translations-version-${process.env.I18N}/${lng}.json`;
          if (isShadowMode) {
            path = shadowModeParams.host + path;
          }
          return path;
        },
      },
    ],
    backends: [i18nBackendHttp],
  };

  try {
    if (localStorage && typeof localStorage !== 'undefined') {
      const prefix = isShadowMode ? shadowRootModePrefix : 'i18next_res_';

      backend.backends = [i18nBackendLS, ...(backend.backends ?? [])];
      backend.backendOptions = [{ prefix, versions }, ...(backend.backendOptions ?? [])];
    }
  } catch (error) {
    console.info('🌐 i18n backend error', error);
  }

  return backend;
};

const defaultProps = {
  backend: getBackend(),
  defaultNS: 'translations',
  defaultValue: ' ',
  fallbackLng: 'en',
  interpolation: {
    defaultVariables: {
      DOMAIN: 'BETSY.COM',
    },
  },
  keySeparator: false,
  languages,
  lng,
  load: 'all',
  lowerCaseLng: true,
  ns: ['translations'],
  nsSeparator: ':::',
  partialBundledLanguages: true,
  react: {
    bindI18n: 'languageChanged',
    bindStore: false,
    omitBoundRerender: true,
    usePureComponent: true,
    useSuspense: true,
  },
} as const;

i18n.use(initReactI18next).use(i18nBackend).init(defaultProps);
